import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    }, {
        path: '',
        component: AdminLayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
            },
            {
                path: '',
                loadChildren: () => import('./catalagos/catalagos.module').then(m => m.CatalagosModule)
            },
            {
                path: '',
                loadChildren: () => import('./taller-productos/taller.module').then(m => m.TallerModule)
            },
            {
                path: '',
                loadChildren: () => import('./persona/persona.module').then(m => m.PersonaModule)
            },
            {
                path: '',
                loadChildren: () => import('./direccion/direccion.module').then(m => m.DireccionModule)
            },
            { path: '', loadChildren: () => import('./usuarios/usuarios.module').then(m => m.UsuariosModule) },
            {
                path: '',
                loadChildren: () => import("./empleado/empleado.module").then(m => m.EmpleadoModule)
            },
            {
                path: '',
                loadChildren: () => import("./creditos/creditos.module").then(m => m.CreditosModule)
            },
            {
                path: '',
                loadChildren: () => import("./reportes/reportes.module").then(m => m.ReportesModule)
            },
        ]
    },

    {
        path: '',
        loadChildren: () => import("./security/security.module").then(m => m.SecurityModule)
    },
    {
        path: '',
        component: AuthLayoutComponent
    }
];
